import { render, staticRenderFns } from "./m-orm-view-dialog.vue?vue&type=template&id=fcb87294&lang=pug&"
import script from "./m-orm-view-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-view-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-view-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports